import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

/**
 * Emit a event when clicked outside of the element
 *
 * __Usage :__
 *   (ngxClickOutside)="closeDropdown()"
 *
 * __Example :__
 *   <div (ngxClickOutside)="closeDropdown()"></div>
 *
 * Module {@link ClickOutsideSharedDirectiveModule}
 */
@Directive({
    selector: '[ngxClickOutside]'
})
export class ClickOutsideDirective {
    // tslint:disable-next-line:prefer-output-readonly
    @Output() ngxClickOutside = new EventEmitter<MouseEvent>();

    constructor(
        private elementRef: ElementRef
    ) {}

    @HostListener('document:click', ['$event']) onDocumentClick(event: MouseEvent): void {
        const targetElement = event.target as HTMLElement;

        // Check if the click was outside the element
        if (targetElement && !this.elementRef.nativeElement.contains(targetElement)) {
            this.ngxClickOutside.emit(event);
        }
    }
}
